import React, { useContext } from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import { QuickAppointmentContext } from '../../Context';
import { convertMilitaryStringToAmPm } from '../../helper';
import useStyles from '../styles';
import RecurringPlanString from '../../RecurringAppointments/RecurringPlanString';

const Schedule = () => {
  const {
    scheduleData,
    isRecurring,
    rruleAttributes,
    rruleCombined,
    activeStep,
    selectedTimeSlot,
    allSteps,
  } = useContext(QuickAppointmentContext);

  const classes = useStyles();

  if (activeStep < allSteps.indexOf('Cost Preview')) {
    return <div className={classes.main} />;
  }

  if (isRecurring) {
    return (
      <div className={classes.main}>
        <Typography className={classes.typography} variant="caption">
          These are repeat appointments
        </Typography>
        <Typography className={classes.typography} variant="caption">
          Starting on{' '}
          {moment(rruleAttributes.dtstart).format('dddd, MMMM D, YYYY')}
        </Typography>
        <Typography className={classes.typography} variant="caption">
          <RecurringPlanString
            rruleCombined={rruleCombined}
            variant="caption"
            selectedTimeSlot={selectedTimeSlot}
          />
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.main}>
      {scheduleData?.selected_date && (
        <Typography className={classes.typography} variant="caption">
          {moment(scheduleData.selected_date).format('dddd, MMMM D, YYYY')}{' '}
        </Typography>
      )}
      {scheduleData?.planned_arrival_time && (
        <Typography className={classes.typography} variant="caption">
          {convertMilitaryStringToAmPm(scheduleData.planned_arrival_time)} -{' '}
          {convertMilitaryStringToAmPm(scheduleData.planned_departure_time)}{' '}
          {/* (EST){' '} */}
          {new Date().toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'long' }).substring(4).match(/\b(\w)/g).join('')}
        </Typography>
      )}
      {scheduleData?.confirmed_appointment_start_time && (
        <Typography className={classes.typography} variant="caption">
          {scheduleData.confirmed_appointment_start_time}{' '}
        </Typography>
      )}
      {scheduleData?.service_vehicle_name && (
        <Typography className={classes.typography} variant="caption">
          {scheduleData.service_vehicle_name}
        </Typography>
      )}
      {scheduleData?.key_exchange_note && (
        <Typography className={classes.typography} variant="caption">
          Key location: {scheduleData.key_exchange_note}
        </Typography>
      )}
      {scheduleData?.admin_note && (
        <Typography className={classes.typography} variant="caption">
          Admin note: {scheduleData.admin_note}
        </Typography>
      )}
    </div>
  );
};

export default Schedule;
